//Core
import React from "react"

//Components
import Seo from "../../container/Layout/Seo"
import SimpleFooter from "../../container/Layout/SimpleFooter"
import Deposit from '../../modules/deposit';

//Styles
import "../../styles/main.scss"
import "./index.css"

const DepositPage = () => (
  <>
    <Seo
      title={`Депозит від ТАСКОМБАНК! Настав час заробити ще!`}
      description={`Новий депозит від ТАСКОМБАНК! Свобода вибору умов по депозитному вкладу. Вигідні відсоткові ставки. Залиште заявку, і наш менеджер зв'яжеться з вами та призначить зустріч у відділенні.`}
      link={`https://tascombank.ua/promo/deposit/`}
    ></Seo>
    <Deposit></Deposit>
  </>
)

export default DepositPage
